import axios, { AxiosResponse } from 'axios';
import { FetchStickerLoungesType } from '../redux/lounges/slice';
import { Lounge } from '../redux/lounges/types';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { buildLoungeAuthHeaders } from '../utils/loungeAuthHeader';
export const getStickerLoungesApi = async ({
  emojiData,
}: FetchStickerLoungesType) => {
  const responseBody = (response: AxiosResponse) => response.data;
  const ddd = emojiData;
  const token = localStorage.getItem('token');
  const apiEndpoint = GET_BASE_URL + '/api/v1/getemoji';
  const { data } = await axios
    .get<Lounge[]>(`${apiEndpoint}`, {
      headers: {
        ...buildLoungeAuthHeaders(token),
      },
    })
    .then(responseBody);
  return data;
};
